

















































































import {Component, Prop, Watch} from 'vue-property-decorator'
import {mixins} from "vue-class-component"
import dataProxy from "@/services/data-proxy.service"
import {PodsetnikVozila, PrimaocPodsetnika} from "@/services/BackendProxies";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import {validEmail} from "@/utils/validations";

@Component({})
export default class PodsetnikVozilaDialog extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    @Prop({default: false}) dialogVozila!: boolean;
    @Prop({default: undefined}) voziloId!: number;
    @Prop() podsetnikVozilaRow!: PodsetnikVozila;
    @Prop({default: undefined}) dateFromCalendar!: Date;

    dialogVozilaData = false;
    columns = [];

    get invalidEmail() {
        const invalidEmails = this.podsetnikVozila.primaoci.filter(x => !validEmail(x.email));
        return invalidEmails.length > 0;
    };

    get isInvalid() {
        return !this.podsetnikVozila.datum && !this.podsetnikVozila.stanjeKilometraze || !this.podsetnikVozila.voziloId
            || !this.podsetnikVozila.opis || !this.podsetnikVozila.upozoriPre || this.invalidEmail
    }

    selected = 'selektovanDatum';

    podsetnikVozila = new PodsetnikVozila(PodsetnikVozila.fromJS({primaoci: [new PrimaocPodsetnika]}));

    async created() {
        if (this.voziloId) {
            this.podsetnikVozila.voziloId = this.voziloId;
        }
        this.columns = [
            {field: 'osobaId', title: this.$i18n.t('osobe'), width: 300,  formatter: this.osobeFormatter},
            {field: 'email', title: this.$i18n.t('email'), width: 260, formatter: this.emailFormatter},
            {field: 'ukljucen', width: 30, title: this.$i18n.t('ukljucen'), formatter: (value, row) => this.ukljucenFormatter(value,row)},
            {field: 'action', width: 10, align: 'right', formatter: `<i class="fa fa-trash text-danger"></i>`}
        ];

    }

    osobeFormatter(value, row) {
        return this.vueFormatter({
            template: `<mf-zaposleni-pripadnost :disabled="row.email !== undefined" parent="#voziloDialog .modal-body"
                                        v-model="row.osobaId" @input="zaposleniChange(row)"></mf-zaposleni-pripadnost>`,
            data: { row },
            store: this.$store,
            methods: {zaposleniChange: this.zaposleniChange}
        })
    }

    zaposleniChange(row: PrimaocPodsetnika) {
        row.email = row.osobaId ? undefined : row.email;
        if (!row.osobaId) {
            row.osobaId = undefined;
        }
    }

    emailFormatter(value, row) {
        return this.vueFormatter({
            template: `
                <ValidationField v-slot="{classes}" rules="email" slim :immediate="true">
                    <input type="text" :disabled="row.osobaId" :class="classes"
                           class="form-control grayInput" @keypress.enter="dodajPrimaoca" v-model.lazy="row.email">
                </ValidationField>`,
            data: {row},
            methods: {dodajPrimaoca: this.dodajPrimaocaPodsetnikuVozila}
        })
    }

    ukljucenFormatter(value, row) {
        return this.vueFormatter({
            template: `<b-form-checkbox v-model="row.ukljucen" switch></b-form-checkbox>`,
            data: { row }
        })
    }

    async onVoziloCellClick(field, value, row) {
        if (field === 'action') {
            this.podsetnikVozila.primaoci = this.podsetnikVozila.primaoci.filter(x => x != row);
        }
    }

    dodajPrimaocaPodsetnikuVozila() {
        this.podsetnikVozila.primaoci.push(PrimaocPodsetnika.fromJS({ukljucen: true}));
    }

    changeRadioButtonSelected($event) {
        this.selected = $event.target.value;
    }

    async sacuvajPodsetnikVozila() {
        const valid = await (<any>this.$refs.observer).validate();
        if (!valid || this.isInvalid) {
            this.showError('podaci nisu validni');
            return;
        }
        this.podsetnikVozila.primaoci = this.podsetnikVozila.primaoci.filter(x => x.osobaId || x.email);
        console.log(this.podsetnikVozila);
        this.podsetnikVozila = await this.saveData(() => dataProxy.sacuvajPodsetnikVozila(this.podsetnikVozila))();
        this.podsetnikVozila = new PodsetnikVozila(PodsetnikVozila.fromJS({primaoci: [new PrimaocPodsetnika]}));
        if (this.voziloId) {
            this.podsetnikVozila.voziloId = this.voziloId;
        }
        this.osveziTabelu();
    }

    osveziTabelu() {
        this.$emit('sacuvajPodsetnikVozila');
    }

    @Watch('dialogVozila') onDialogVozilaChange(value) {
        this.dialogVozilaData = value;
        this.$nextTick(() => (<any>this.$refs.observer).validate());
        if (value) {
            this.podsetnikVozila = new PodsetnikVozila(PodsetnikVozila.fromJS({primaoci: [new PrimaocPodsetnika]}));
            if (this.voziloId) {
                this.podsetnikVozila.voziloId = this.voziloId;
            }
            if (this.dateFromCalendar) {
                this.podsetnikVozila.datum = this.dateFromCalendar;
            }
        }
    }

    @Watch('dialogVozilaData') onDialogVozilaDataChange(value) {
        this.$emit('input', value)
    }

    @Watch('podsetnikVozilaRow') onPodsetnikVoziloRowClicked(row) {
         console.log(row);
            if (row) {
                this.podsetnikVozila = row;
                if (row.datum) {
                    this.selected = 'selektovanDatum';
                }
                if (row.stanjeKilometraze) {
                    this.selected = 'selektovanaKM';
                }
            }
    }

    @Watch('selected') onSelectedChange(selected) {
        if (selected == 'selektovanDatum') {
            this.podsetnikVozila.stanjeKilometraze = undefined;
        }
        else if (selected == 'selektovanaKM') {
            this.podsetnikVozila.datum = undefined;
        }
    }

    loader = async (params, success, failure) => {
        const opisiVozila = await dataProxy.vratiOpisePodsetnikaVozila(params.data.term);
        success(opisiVozila);
    };

    processResults(data: any[]) {
        return {
            results: data.map((x) => ({id: x, text: x}))
        }
    }

    postBody() {
        this.vueFormatterPostBody();
        const input = $('input.invalid');
        if (input.length) {
            this.$nextTick(() => input[0].focus());
        }
    }

}
